import React from "react";

export function ErrorState({ message, onRetry }) {
  return (
    <div style={{ textAlign: "center", padding: "3rem 1rem" }}>
      <p style={{ color: "#c0392b", fontWeight: "600", marginBottom: "0.5rem" }}>
        Something went wrong
      </p>
      <p style={{ color: "#666", marginBottom: "1rem", fontSize: "0.9rem" }}>
        {message || "An unexpected error occurred."}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: "0.4rem 1.2rem",
            background: "#020263",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message }) {
  return (
    <div style={{ textAlign: "center", padding: "3rem 1rem" }}>
      <p style={{ color: "#888", fontSize: "0.95rem" }}>
        {message || "No data found."}
      </p>
    </div>
  );
}
